class MetaRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
  }

  get()
  /*: (Promise<Object>)*/
  {
    if (this.cache != null) return Promise.resolve(this.cache);
    const req = new this.client.Request(`/users/auth/login/okta`);
    req.authType = req.AUTH_TYPES.AUTH_FORBIDDEN;
    return this.client.get(req);
  }

}

module.exports = MetaRepo;